function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.546 12.0004L22.2382 4.30814L23.8245 2.72183C24.0585 2.48783 24.0585 2.10757 23.8245 1.87356L22.1272 0.176256C21.8932 -0.0577516 21.5129 -0.0577516 21.2789 0.176256L12.0004 9.45479L2.72184 0.175505C2.48783 -0.0585018 2.10757 -0.0585018 1.87356 0.175505L0.175505 1.87281C-0.0585018 2.10682 -0.0585018 2.48708 0.175505 2.72109L9.45479 12.0004L0.175505 21.2789C-0.0585018 21.5129 -0.0585018 21.8932 0.175505 22.1272L1.87281 23.8245C2.10682 24.0585 2.48708 24.0585 2.72108 23.8245L12.0004 14.546L19.6926 22.2382L21.2789 23.8245C21.5129 24.0585 21.8932 24.0585 22.1272 23.8245L23.8245 22.1272C24.0585 21.8932 24.0585 21.5129 23.8245 21.2789L14.546 12.0004Z",
  fill: "#BDCBDA"
});

function SvgWrong(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrong);
export default __webpack_public_path__ + "static/media/wrong.92ddae0f.svg";
export { ForwardRef as ReactComponent };